import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Home from '../pages/Home';
import AddManageVideo from '../pages/videos/AddManageVideo';
import VideoCreateForm from '../pages/VideoCreateForm';
import AddManageCourse from '../pages/CreateCourse/AddManageCourse';
import AddManageQuestionnaire from '../pages/Questions/AddManageQuestionnaire';
import AddManageResource from '../pages/Resource/AddManageResource';
import LoginHome from '../pages/Home/LoginHome';
import AllCourses from '../pages/Courses/AllCourses';
import NotFound from '../pages/NotFound';
import ViewCourse from "../pages/Courses/ViewCourse";
import AssignCourse from "../pages/Courses/AssignCourse";
import AssignCourseOnGroup from "../pages/Courses/AssignCourseOnGroup";
import Rti from "../pages/Public/Rti";
import WebsitePolicy from "../pages/Public/WebsitePolicy";
import PrivacyPolicy from "../pages/Public/PrivacyPolicy"
import TermsAndConditions from "../pages/Public/T&C";
import CopyrightPolicy from "../pages/Public/CopyrightPolicy";
import ContactUs from "../pages/Public/Contact";
import WebInfoManager from "../pages/Public/WebManger";
import LoginPage from "../pages/LoginPage";
import AboutUs from "../pages/Public/AboutUs";
import Registeration from "../pages/Registeration";
// import Rolewisetracking from '../pages/reports/Rollwisetracking';
import { AdminSettings } from '../pages/settings';
import { AllReports } from '../pages/reports';

function WithParams(Component) {
  return function WrappedComponent(props) {
    const params = useParams();
    return <Component {...props} {...params} />;
  };
}
const WithParamsComponent = WithParams(ViewCourse);

function RoutesComponent() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Registeration/>} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/rti" element={<Rti />} />
      <Route path="/websitepolicy" element={<WebsitePolicy />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/terms&conditions" element={<TermsAndConditions />} />
      <Route path="/copyrightpolicy" element={<CopyrightPolicy />} />
      <Route path="/contact" element={<ContactUs />} />
       <Route path="/wim" element={<WebInfoManager />} />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <LoginHome />
          </PrivateRoute>
        }
      />
      <Route
        path="/createcourse"
        element={
          <PrivateRoute>
            <AddManageCourse />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanagevideo"
        element={
          <PrivateRoute>
            <AddManageVideo />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanagequestionnaire"
        element={
          <PrivateRoute>
            <AddManageQuestionnaire />
          </PrivateRoute>
        }
      />
      <Route
        path="/addmanageresource"
        element={
          <PrivateRoute>
            <AddManageResource />
          </PrivateRoute>
        }
      />
      <Route
        path="/allcourses"
        element={
          <PrivateRoute>
            <AllCourses />
          </PrivateRoute>
        }
      />
      <Route
        path="/viewcourses/:courseId"
        element={
          <PrivateRoute>
            <WithParamsComponent />
          </PrivateRoute>
        }
      />
      <Route
        path="/assigncourse"
        element={
          <PrivateRoute>
            <AssignCourse />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/rolewisetracking"
        element={
          <PrivateRoute>
            <Rolewisetracking/>
          </PrivateRoute>
        }
      /> */}
       <Route
        path="/reports"
        element={
          <PrivateRoute>
            <AllReports/>
          </PrivateRoute>
        }
      />
      <Route 
        path="/adminsettings"
        element={
          <PrivateRoute>
            <AdminSettings />
          </PrivateRoute>
        }
      >
      </Route>
      <Route
        path="/demo"
        element={
          <PrivateRoute>
            <VideoCreateForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/*"
        element={<NotFound />}
      />
    </Routes>
  );
}
export default RoutesComponent;
